import { Color as PersonaColor, Spacing } from '@persona-id/design-tokens';
import Color from 'color';
import styled from 'styled-components';

import { TransitionDuration } from 'design-system/variables/transitions';

// TODO: this should take styles from SST
const IconButton = styled('button')`
  cursor: pointer;
  pointer-events: auto;
  height: ${Spacing[6]};
  width: ${Spacing[6]};
  background: none;

  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;

  border-radius: ${({ theme }) => theme.borderRadius};
  outline: 0 !important;

  transition:
    box-shadow ${TransitionDuration.Fast},
    background-color ${TransitionDuration.Fast};
  box-shadow: 0 0 0 2px transparent;

  :hover:not(:disabled) {
    background-color: ${Color(PersonaColor.CoreSlate200).fade(0.5).rgb().string()};
  }

  :focus-visible:not(:disabled) {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colorPrimary};
  }

  :active:not(:disabled) {
    background-color: ${Color(PersonaColor.CoreSlate300).fade(0.5).rgb().string()};
  }

  svg {
    color: ${({ theme }) => theme.colorFont};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.25;
  }
`;

export default IconButton;
